<!--
  IpForm : Ipv6 Component

  @since 2017-11-10
  @author kdydesign.kim
-->

<template>
  <div class="inline-group bs bs-q-ip-input bs-q-ip-input-default bs-q-ip-input-ipV4 bs-q-ip-input-mask">
    <!--TAMS Auth/HA Force 제거-->
    <q-input ref="ipAddress"
             type="text"
             :style="`width:${width}; ime-mode: disabled;`"
             class="bs bs-q-input bs-q-input-default"
             v-validate="disable ? '' : required ? 'required|isValidIPv6' : isValid && ipV6Address ? 'isValidIPv6' : ''"
             :key="name"
             :name="name"
             :value="ipV6Address"
             :error="dataVvScope === '' ? errors.has(name) : errors.has(`${dataVvScope}.${name}`)"
             :disable="disable"
             :readonly="readonly"
             :placeholder="$tc('cmn.ipv6Addr', 1)"
             :data-vv-scope="dataVvScope || null"
             @input="onInputIPv6Address"
    >
      <q-tooltip
        self="bottom middle"
        anchor="top middle"
        class="bs bs-q-tooltip bs-q-tooltip-default"
        :offset="[10, 10]"
      >
        <em>{{ $t('cmn.title_validIPv6') }}</em>
      </q-tooltip>
    </q-input>
    <!--TAMS Auth/HA Force 제거-->
    <q-btn class="bs bs-q-btn-sm bs-q-btn-icon-sm bs-q-btn-line"
           v-clipboard:copy="ipV6Address"
           :title="`IP ${$t('cmn.copy')}`"
           :disable="disable"
           :readonly="readonly"
    >
      <q-icon class="bs-q-btn-icon bs-q-btn-icon-ip-copy-sm"/>
    </q-btn>

    <!-- Ping 버튼 -->
    <!--TAMS Auth/HA Force 제거-->
    <ping-button v-if="ping"
                 key="ipV6PingBtn"
                 :readonly="readonly"
                 title="IPv6 Ping"
                 :value="ipV6Address"
    />

    <div v-if="usePrefix"
         class="bs"
    >
      <span class="contents-option-con">/</span>
      <!--TAMS Auth/HA Force 제거-->
      <q-input ref="prefix"
               type="text"
               align="center"
               style="width:50px; ime-mode: disabled;"
               class="bs bs-q-input bs-q-input-default marL0 ipv6-block-ime"
               v-model.number="prefixValue"
               :maxlength="3"
               v-validate="disable ? '' : required && usePrefix ? `required|isValidPrefix:${prefixMin},${prefixMax}` : isValid && prefixValue ? `isValidPrefix:${prefixMin},${prefixMax}` : ''"
               :key="`${name}_prefix`"
               :name="`${name}_prefix`"
               :error="dataVvScope === '' ? errors.has(`${name}_prefix`) : errors.has(`${dataVvScope}.${name}_prefix`)"
               :disable="disable"
               :readonly="readonly"
               :data-vv-scope="dataVvScope || null"
               @input="onInputPrefix"
               @focus="$refs.prefix.select()"
      >
        <q-tooltip
          self="bottom middle"
          anchor="top middle"
          class="bs bs-q-tooltip bs-q-tooltip-default"
          :offset="[10, 10]"
        >
          <em>{{ $t('cmn.valueRange', {'min': prefixMin, 'max': prefixMax}) }}</em>
        </q-tooltip>
      </q-input>
    </div>
  </div>
</template>

<script>
  import PingButton from '../PingButton'

  const ipv6Regex = /^((?=.*::)(?!.*::.+::)(::)?([\dA-F]{1,4}:(:|\b)|){5}|([\dA-F]{1,4}:){6})((([\dA-F]{1,4}((?!\3)::|:\b|$))|(?!\2\3)){2}|(((2[0-4]|1\d|[1-9])?\d|25[0-5])\.?\b){4})$/i

  export default {
    name: 'Ipv6Address',
    components: {
      PingButton
    },
    data () {
      return {
        self: this,
        ipV6Address: '',
        prefixValue: void 0
      }
    },
    props: {
      ip: {
        type: String,
        default: void 0
      },
      name: {
        type: String,
        required: true
      },
      width: {
        type: String,
        default: '280px'
      },
      ping: {
        type: Boolean,
        default: false
      },
      error: {
        type: Boolean,
        default: false
      },
      prefix: {
        type: [Number, String],
        default: void 0
      },
      isValid: {
        type: Boolean,
        default: true
      },
      prefixMin: {
        type: [Number, String],
        default: 1
      },
      prefixMax: {
        type: [Number, String],
        default: 128
      },
      disable: {
        type: Boolean,
        default: false
      },
      required: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      validator: {
        type: Object,
        default: void 0,
        validator: function (value) {
          return value
        }
      },
      dataVvScope: {
        type: String,
        default: ''
      },
      authForce: {
        type: Boolean,
        default: false
      },
      haForce: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      usePrefix () {
        return this.prefix !== void 0
      }
    },
    created () {
      // 전달된 Validator가 없을경우 자기 자신의 Validator 객체를 전달한다.
      this.$validator = this.validator || this.$validator
    },
    mounted () {
      this.ipV6Address = this.ip

      if (this.usePrefix) {
        this.prefixValue = this.prefix
      }

      let inputCons = this.$el.getElementsByTagName('input')

      _.each(inputCons, (thisCon, index) => {
        thisCon.addEventListener('paste', (event) => {
          this.onPaste(event, index)
        })
      })
    },
    beforeDestroy () {
      this.clear()

      // 셀프 객체 초기화
      this.self = null
    },
    methods: {
      /*
        이름: onInputIPv6Address
        설명: IPv6 주소 입력 시 유효성 검사를 수행하고 상위 컴포넌트로 값을 동기화한다.
      */
      onInputIPv6Address (value) {
        // 값 가져오기
        this.ipV6Address = value.replace(/[^a-fA-F0-9:]/gi, '')

        // Q-input 내부모델 차단
        this.$refs.ipAddress.$data.model = this.ipV6Address

        // 유효성 검사 수행
        this.$validator.validateAll()

        // 양방향 바인딩
        this.$emit('update:ip', this.ipV6Address || null)
      },
      /*
        이름: onInputPrefix
        설명: IPv6 프리픽스를 입력한다. 1 ~ 128까지 입력 가능하다.
      */
      onInputPrefix (value) {
        // prefix 값을 숫자형으로 형변환
        const convertPrefix = Number(value.replace(/[^0-9]/gi, ''))

        this.prefixValue = (convertPrefix === 0 || convertPrefix) ? convertPrefix : ''

        // Q-input 내부모델 차단
        this.$refs.prefix.$data.model = this.prefixValue

        // 유효성 검사 수행
        this.$validator.validateAll()

        // 양방향 바인딩
        this.$emit('update:prefix', this.prefixValue)
      },
      /*
        이름: onPaste
        설명: 설정된 IP를 복사한다.
      */
      onPaste (event) {
        const pasteText = event.clipboardData.getData('text/plain')

        if (ipv6Regex.test(pasteText)) {
          this.$emit('update:ip', pasteText)
        }

        event.returnValue = false
      },
      /*
        이름: onBlurIPv6Address
        설명: IP 컴포넌트 포커스를 벗어나면 Replace된 문자열을 모델에 전달한다.
      */
      onBlurIPv6Address (event) {
        const self = this.self
        setTimeout(() => {
          const beforeValue = event.target.value
          const blockHangul = beforeValue.replace(/[^a-fA-F0-9:]/gi, '')
          self.ipV6Address = blockHangul
        }, 1)
      },
      /*
        이름: onKeyUpIPv6Address
        설명: 한글, 특수문자를 빈문자열로 치환하고 모델에 전달한다.
      */
      onKeyUpIPv6Address (event) {
        if (!(event.keyCode >= 37 && event.keyCode <= 40)) {
          const beforeValue = event.target.value
          const blockHangul = beforeValue.replace(/[^a-fA-F0-9:]/gi, '')
          this.ipV6Address = blockHangul
        }
      },
      /*
        이름: onKeyDownIPv6Address
        설명: 특수문자 입력을 차단한다. KeyDown에서 한글을 감지할 수 없으므로 한글은 Up 이벤트에서 처리한다.
      */
      onKeyDownIPv6Address (event) {
        // 키코드 값 가져오기
        const keyCode = event.keyCode

        // 특수기호
        const isSpecWord = (keyCode > 105 && keyCode < 112) || (keyCode > 186 && keyCode < 193) || (keyCode > 218 && keyCode < 223) || keyCode === 32

        if (!event.ctrlKey) {
          if (isSpecWord) { // 알파벳, 특수기호 및 공백 입력 불가
            event.returnValue = false
            event.preventDefault()
          }
        }
      },
      /*
        이름: onBlurPrefix
        설명: 한글, 알파벳, 특수문자를 빈문자열로 치환하고 모델에 전달한다.
      */
      onBlurPrefix (event) {
        const self = this.self
        setTimeout(() => {
          const beforeValue = event.target.value
          const blockHangul = beforeValue.replace(/[^0-9]/gi, '')
          self.prefixValue = blockHangul
        }, 1)
      },
      /*
        이름: onKeyUpPrefix
        설명: 한글, 알파벳, 특수문자를 빈문자열로 치환하고 모델에 전달한다.
      */
      onKeyUpPrefix (event) {
        if (!(event.keyCode >= 37 && event.keyCode <= 40)) {
          const beforeValue = event.target.value
          const blockHangul = beforeValue.replace(/[^0-9]/gi, '')
          // event.target.value = blockHangul
          this.prefixValue = blockHangul
        }
      },
      /*
        이름: onKeyDownPrefix
        설명: IPv6 프리픽스 컴포넌트에서 특수 문자가 입력되지 않도록 분기처리한다.
      */
      onKeyDownPrefix (event) {
        // 키코드로 알파벳과 특수기호를 막는다
        const keyCode = event.keyCode

        // 알파벳 범위 (a ~ z)
        const isAlpha = keyCode > 64 && keyCode < 91

        // 특수기호 및 공백
        const isSpecWord = (keyCode > 105 && keyCode < 112) || (keyCode > 185 && keyCode < 193) || (keyCode > 218 && keyCode < 223) || keyCode === 32

        // 알파벳, 특수기호 및 공백 입력 불가
        if (!event.ctrlKey) {
          if (isAlpha || isSpecWord) {
            event.returnValue = false
            event.preventDefault()
          }
        }
      },
      /*
        이름: onSendPing
        설명: 입력된 IP로 Ping을 호출한다.
      */
      async onSendPing () {
        let pingIp = this.ipV6Address

        const {code, result} = await this.$axios.$get(`/api/co/tools/connect?target=${encodeURIComponent(pingIp)}`)
        if (code === 'ok' && result.connect !== undefined) {
          if (result.connect) {
            this.$alertPopUp.show(this.$t('cmn.success'))
          } else {
            // this.$alertPopUp.show(this.$t('cmn.fail'))

            if (result.msg) {
              // this.$store.state.common.common.components.alertDialog.show(result.msg, 'error')
              this.$alertPopUp.show(result.msg)
            }
          }
        }
      },
      /*
        이름: clear
        설명: 컴포넌트를 초기상태로 되돌린다.
      */
      async clear () {
        // 유효성 검사 초기화
        await this.$validator.reset()

        // 내부 모델 초기화
        this.ipV6Address = ''
        this.prefixValue = void 0

        // IPv6에 관련된 에러백 제거
        this.errors.remove(this.name)

        // Prefix에 관련된 에러백 제거
        this.errors.remove(`${this.name}_prefix`)
      },
      /*
        이름: validate
        설명: IPv6 컴포넌트의 유효성 검사를 수행한다.
      */
      async validate () {
        const resValidate = await this.$validator.validateAll()

        return resValidate
      }
    },
    watch: {
      ip (ipAddress) {
        this.ipV6Address = ipAddress || ''
      },
      prefix (prefix) {
        this.prefixValue = (prefix === 0 || prefix) ? prefix : void 0
      }
    }
  }
</script>
<style>
</style>
